import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LeftSidebar from './LeftSidebar';
import Topbar from './Topbar';
import Footer from './Footer';
import { Link,useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from '../Config';
const Profile = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [members, setMembers] = useState(null);
    const [addresses, setAddresses] = useState([]);

    const [contacts, setContacts] = useState([]);
    const [others, setOthers] = useState([]);



    useEffect(() => {
        const fetchData = async () => {
            try {
                
                const memberd = localStorage.getItem('member');
                //console.log(user);
                const token = localStorage.getItem('token');
                if (!memberd || !token) {
                    console.error("User or token not found in localStorage");
                    return;
                }
                const resp = await axios.get(`${BASE_URL}/api/member_view/${memberd}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                //alert(resp.data.members.id)
                setMembers(resp.data.members);
                setAddresses(resp.data.addresses);
                setContacts(resp.data.contacts);
                setOthers(resp.data.others);
                console.log(resp.data.members);

            } catch (error) {
                console.error("Error fetching  data", error);
            }
        };

        fetchData();
    }, []);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
    <>
        <div id="page-top">
            <div id="wrapper">
                <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                <div id="content-wrapper" classNameName="d-flex flex-column">
                    <div id="content">
                        <Topbar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                        <div classNameName="container-fluid">
                            <div className='row'>
                            <div classNameName='col-md-12'>
                                <div classNameName='card'>
                                    <div classNameName='card-header py-3' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                        <div classNameName='row'>
                                            <div classNameName='col-md-6 d-flex left-content-end'>
                                                <h6 classNameName="font-weight-bold text-primary left" style={{textAlign: 'left',
    margin: '0 11px 16px',color:'#050505',fontWeight: '800'}}>Profile </h6><link></link>
                                            </div>
                                            <div classNameName='col-md-6 d-flex justify-content-end'>
                                                <i classNameName="fa fa-arrow-left" onClick={() => navigate(-1)}></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div classNameName='card-body' style={{ overflowY: 'auto' }}>
                                        <div className="col-sm-12 form-group">
                                                                          
                                            <table  className="table table-borderless text-left"  style={{ margin: '0 0 -9px', border: '1px solid'}}>
                                            {
                                                members ? (
                                            <thead>
                                                <tr>
                                                <td className="col-md-6"><strong>Membership</strong></td>
                                                <td className="col-md-6">{members.membership}</td>
                                                </tr>
                                                <tr>
                                                <td className="col-md-6"><strong>Company Name</strong></td>
                                                    <td className="col-md-6">{members.company_name}</td>
                                                </tr>
                                                    <tr>
                                                <td className="col-md-6"><strong>Nature of Business</strong></td>
                                                    <td className="col-md-6">{members.nature_of_bussiness}</td>
                                                </tr>
                                                <tr>
                                                
                                                <td className="col-md-6"><strong>Registered Contact No.</strong></td>
                                                <td className="col-md-6">
                                                {members.registered_contact_no}
                                                </td>
                                                </tr>
                                                <tr>
                                                    <td className="col-md-5"> <strong>Product Category (Handlooms/ Powerlooms)</strong></td>
                                                    <td className="col-md-7">
                                                
                                                    {members.product_category}
                                                    
                                                    
                                                </td>
                                                </tr>
                                                <tr>
                                                    <td className="col-md-5"> <strong>Other Category </strong></td>
                                                    <td className="col-md-7">
                                                
                                                    {members.other_product_category}
                                                    
                                                    
                                                </td>
                                                </tr>
                                            </thead>
                                                ):''}
                                            </table>
                                            
                                        </div><br />
        
                                        
                                        
                                        <div className="col-sm-12 form-group">
                                            <table  className="table table-borderless text-left" id="dperson" style={{margin: '0 0 -9px',border: '1px solid'}}>
                                            <thead>
                                                <tr>
                                                <td><strong>Contact Person Name</strong></td>
                                                <td><strong>Gender</strong></td>
                                                <td><strong>Contact Person No.</strong></td>
                                                </tr>
                                                {contacts && contacts.map((contact, index) => (
                                                    <tr key={index}>
                                                        <td>{contact.contact_person_name}</td>
                                                        <td>{contact.gender}</td>
                                                        <td>{contact.contact_person_no}</td>
                                                    </tr>
                                                ))}
                                            </thead>
                                            </table>
                                        </div><br />
                                        <div className="col-sm-12 form-group">
                                            <table  className="table table-borderless text-left" id="daddress" style={{margin: '0 0 -9px',border:'1px solid'}}>
                                            <thead>
                                                <tr>
                                                <td><strong>Title(ex.Branch/Head Office)</strong></td>
                                                <td><strong>Address</strong></td>
                                                </tr>
                                                
                                                {addresses && addresses.map((address, index) => (
                                                    <tr key={index}>
                                                        <td>{address.title}</td>
                                                        <td>{address.address}</td>
                                                    </tr>
                                                ))}
                                                
                                                
                                            </thead>
                                            </table>
                                        </div><br />
                                        <div className="col-sm-12 form-group">
                                            <table  className="table table-borderless text-left" id="dperson" style={{margin: '0 0 -9px',border:'1px solid'}}>
                                            <thead>
                                            {
                                                members ? (
                                                <tr>
                                                <td><strong>Year of Establishment</strong></td>
                                                <td>{members.year_of_establishment}</td>
                                                <td><strong>Company Email</strong></td>
                                                <td>{members.company_email}</td>
                                                </tr>
                                                ):''}
                                                
                                                
                                            </thead>
                                            </table>
                                        </div>
                                        <div className="col-sm-12 form-group">
                                            <table  className="table table-borderless text-left"  style={{ margin: '0 0 -9px',border:'1px solid'}}>
                                            <thead>
                                                <tr>
                                                <td><strong>Other Contact No.(Optional)</strong></td>
                                                </tr>
                                                
                                                {others && others.map((other, index) => (
                                                    <tr key={index}>
                                                        <td>{other.other_contact}</td>
                                                    </tr>
                                                ))}
                                                
                                                </thead>
                                                
                                            
                                            </table>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                         </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            
        
    </>
    );
};

export default Profile;
